import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05ee6658"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ee6658')) {
      api.createRecord('05ee6658', component.options)
    } else {
      api.reload('05ee6658', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05ee6658", function () {
      api.rerender('05ee6658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Events/EventDashboard/index.vue"
export default component.exports